import {COOKIES_TYPES, getCookie} from "./cookieHelper";
import {getMainDataset, getCspNonce} from "./mainHelper";

const LINKEDIN_PARTNER_ID = "2835714";
const BING_TAG_ID = "5976443";
const BING_TAG_TYPE = "uetq";
const GOOGLE_ANALYTICS_GA_ID = "ga-disable-UA-68317918-1";
const GOOGLE_ANALYTICS_GID_ID = "gid-disable-UA-68317918-1";
const FACEBOOK_PIXEL_ID = "168175908495222";
const GTM_ID = "GTM-KQDCMVHK";
const PIXIS_CONVERSION_ID = "DC-11471913/invmedia/dhl-e00+standard";
const PIXIS_CONVERSION_ID_2 = "G-SZBM9L4HKC/invmedia/dhl-e00+standard";
const MARKETO_MUNCHKIN_ID = "903-EZK-832";
const MARKETO_MUNCHKIN_WS_INFO = "j0hQcNjOKwUA";
const GOOGLE_ANALYTICS_TRACKING_ID = "UA-68317918-1";
const TWITTER_PIXEL_ID = "nxpcc";
export const GTM_CONFIG_ID= "G-SZBM9L4HKC";

/**
 * Initialise et pousse des données vers la couche de données Google Tag Manager (dataLayer).
 *
 * @example
 * gtag('event', 'conversion', { 'send_to': 'AW-123456789/AbC-D_efG-h12_34-567' });
 */
export function gtag(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
}

/**
 * Initialise le pixel de suivi LinkedIn si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Utilise l'ID partenaire LinkedIn '2835714'.
 */
function initLinkedInCookie() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    const _linkedin_partner_id = LINKEDIN_PARTNER_ID;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);

    (function(){
        const s = document.getElementsByTagName("script")[0];
        const b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        b.setAttribute('nonce', getCspNonce());
        s.parentNode.insertBefore(b, s);
    })();
}

/**
 * Désactive Google Analytics si l'utilisateur n'a pas donné son consentement pour les cookies de performance.
 *
 * @description Cette fonction désactive les trackers Google Analytics en définissant les propriétés
 * `ga-disable-UA-68317918-1` et `gid-disable-UA-68317918-1` à `true`.
 */
export function disableGoogleAnalyticsPerformanceCookie() {
    window[GOOGLE_ANALYTICS_GA_ID] = true;
    window[GOOGLE_ANALYTICS_GID_ID] = true;
}

/**
 * Initialise le suivi Bing Ads si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Utilise l'ID de tag UET '5976443'.
 */
function initBingAdsCookies() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    const initBing = function (w, d, t, r, u) {
        var f, n, i;
        w[u] = w[u] || [], f = function () {
            var o = {ti: BING_TAG_ID};
            o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
        }, n = d.createElement(t), n.src = r, n.async = 1, n.setAttribute('nonce', getCspNonce()), n.onload = n.onreadystatechange = function () {
            var s = this.readyState;
            s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
        }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
    }
    initBing(window, document, "script", "//bat.bing.com/bat.js", BING_TAG_TYPE);
}

/**
 * Initialise le pixel de suivi Twitter si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Initialise le pixel avec l'ID 'nxpcc' et envoie un événement PageView.
 */
function initTwitterCookies() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    const initTwitter = function (e, t, n, s, u, a) {
        e.twq || (s = e.twq = function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = '//static.ads-twitter.com/uwt.js', u.setAttribute('nonce', getCspNonce()),
            a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a))
    }
    initTwitter(window, document, 'script');
    // Insert Twitter Pixel ID and Standard Event data below
    twq('init', TWITTER_PIXEL_ID);
    twq('track', 'PageView');
}

/**
 * Initialise le pixel Facebook si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Initialise le pixel avec l'ID '168175908495222' et envoie un événement PageView.
 */
function initFacebookCookie() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    const initFacebook = function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        t.setAttribute('nonce', getCspNonce());
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }
    initFacebook(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', FACEBOOK_PIXEL_ID);
    fbq('track', 'PageView');
}

/**
 * Initialise Google Tag Manager si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Charge le script GTM avec l'ID 'GTM-KQDCMVHK' et configure la dataLayer.
 */
export function initGoogleTagManager() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }

    const initGTM = function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.setAttribute('nonce', getCspNonce());
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    }
    initGTM(window, document, 'script', 'dataLayer', GTM_ID);

    gtag('js', new Date());
    gtag('config', GTM_CONFIG_ID);
}

/**
 *
 * Initialise le script Munchkin de Marketo si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Utilise l'ID Munchkin '903-EZK-832'.
 */
function initMunchkinForMarketo(){
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    let didInit = false;
    function initMunchkin() {
        if(didInit === false) {
            didInit = true;
            Munchkin.init(MARKETO_MUNCHKIN_ID, {"wsInfo":MARKETO_MUNCHKIN_WS_INFO});
        }
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.setAttribute('nonce', getCspNonce());
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function() {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
            initMunchkin();
        }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
}

/**
 * Déclenche des événements Facebook Pixel si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @param {string} type - Type d'événement ('track', 'init', etc.)
 * @param {string} title - Nom de l'événement
 * @param {Object} data - Données supplémentaires pour l'événement
 * @param {string} [eventId] - Identifiant partagé avec l'événement équivalent envoyé côté serveur
 *                             (Meta Conversions API), pour permettre à Meta de dédupliquer les deux envois.
 *
 * @example
 * triggerFacebookCookies('track', 'Purchase', { currency: 'EUR', value: 10.00 }, metaEventId);
 */
export function triggerFacebookCookies(type, title, data, eventId) {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    if (eventId) {
        fbq(type, title, data, {eventID: eventId});
    } else {
        fbq(type, title, data);
    }
}

/**
 * Déclenche des événements de conversion DoubleClick/Pixis si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Utilise la conversion ID 'DC-11471913/invmedia/dhl-e00+standard'.
 */
export function triggerPixisCookies() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }

    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': PIXIS_CONVERSION_ID
    });

    /**
     * Ajout d'un event secondaire, PIXIS_CONVERSION_ID n est pas utilisé
     */
    gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': PIXIS_CONVERSION_ID_2
    });

    document.body.insertAdjacentHTML('beforeend',
        '<noscript>' +
        '<img src="https://ad.doubleclick.net/ddm/activity/src=11471913;type=invmedia;cat=dhl-e00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>' +
        '</noscript>'
    );
}

/**
 * Initialise Google Analytics et envoie un pageview si l'utilisateur a donné son consentement pour les cookies de ciblage.
 *
 * @description Utilise le tracking ID 'UA-68317918-1'.
 */
export function triggerGoogleAnalytics() {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        return
    }
    const initGoogleAnalytics = function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
    }
    initGoogleAnalytics(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    if(!window.ga) {
        console.error('Google Analytics not loaded');
        return;
    }
    ga('create', GOOGLE_ANALYTICS_TRACKING_ID, 'auto');
    ga('send', 'pageview');
}

export function initTargetingAnalytics() {
    initFacebookCookie();
    initTwitterCookies();
    initBingAdsCookies();
    initLinkedInCookie();
    initMunchkinForMarketo();
}

/**
 * Vérifie si l'utilisateur a donné son consentement pour un type spécifique de cookie.
 *
 * @param {string} value - Type de consentement à vérifier (ex: 'targeting', 'performance')
 * @returns {boolean} true si l'utilisateur a donné son consentement, false sinon
 *
 * @description Cette fonction utilise le cookie 'EU_OPTIN' qui contient une liste de types de cookies acceptés par l'utilisateur.
 *
 * @example
 * if (hasEuOptinValueInCookies('targeting')) {
 *     // Initialiser les scripts de tracking
 * }
 */
export function hasEuOptinValueInCookies(value) {
    let hasEuOptinTargeting = false;
    const euOptInCookie = getCookie('EU_OPTIN');
    if (euOptInCookie) {
        const euOptInCookieArray = decodeURIComponent(euOptInCookie).split(',');
        hasEuOptinTargeting = euOptInCookieArray.indexOf(value) !== -1;
    }

    return hasEuOptinTargeting;
}

export function setGTMDataLayer(objet) {
    window.dataLayer = window.dataLayer || [];
    if (!objet) return;
    window.dataLayer.push(objet);
}

export function setGTMDataLayerUserIdTypeAndRefValue() {
    const dataSet = getMainDataset();
    if (!dataSet) {
        console.error('No dataset set for GTM');
        return;
    }
    const userId = dataSet.userId || null;
    const type = dataSet.type || null;
    const ref = dataSet.ref || null;

    setGTMDataLayer({
        userid: userId,
        type: type,
        ref: ref
    });
}
